import { useState } from "react";
import axios from "axios";
import { getThemesURL } from "../utils/ConstantsURL";

export function useSearchThemes(token) {
  const [themes, setThemes] = useState([]);
  const [loadingThemes, setLoadingThemes] = useState(false);
  const [errorThemes, setErrorThemes] = useState(null);

  const searchThemes = async (query) => {
    setLoadingThemes(true);
    setErrorThemes(null);
    if (!token) {
      setErrorThemes("No hay sesión válida. Por favor inicia sesión.");
      setThemes([]);
      setLoadingThemes(false);
      return;
    }
    try {
      const response = await axios.get(getThemesURL(), {
        headers: { Authorization: `Bearer ${token}` },
        params: query ? { q: query } : {},
      });
      const temasArray = Array.isArray(response.data.data)
        ? response.data.data
        : [];
      setThemes(temasArray);
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        setErrorThemes(backendMessage);
      } else if (error?.response?.status === 401) {
        setErrorThemes(
          "Credenciales incorrectas. Por favor, inicia sesión nuevamente.",
        );
      } else {
        setErrorThemes(error.message || "Error buscando temas");
      }
      setThemes([]);
    } finally {
      setLoadingThemes(false);
    }
  };

  return { themes, loadingThemes, errorThemes, searchThemes };
}
